import { KPI_METRIC_TYPE, KpiMetricType } from './kpiTypes';

/**
 * Formats a KPI value for display based on its metric type:
 * - NPS (-100..+100): signed integer, e.g. `+8`, `-20`, `0`
 * - scale (0-4): plain number, e.g. `3.5`
 * - percentage: value with `%`, e.g. `60%`
 * - custom: plain number, e.g. `42`
 */
export const formatKpiValue = (value: number, metricType: KpiMetricType): string => {
  switch (metricType) {
    case KPI_METRIC_TYPE.NPS:
      return value > 0 ? `+${value}` : `${value}`;
    case KPI_METRIC_TYPE.SCALE:
    case KPI_METRIC_TYPE.CUSTOM:
      return `${value}`;
    case KPI_METRIC_TYPE.PERCENTAGE:
    default:
      return `${value}%`;
  }
};
